import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { history } from '../../config/history';
import MainRouter from '../../router/Router';
import { AuthRouter } from '../../router/AuthRouter';
import { getInitialDataRequest } from './redux/actions/user_info.actions';
import '../../scss/app.scss';
import api from './socket';

const loginPath = '/login';
class App extends Component {
    componentDidMount() {
        const { dispatch } = this.props;

        let token = '';

        if (localStorage) {
            token = localStorage.getItem('token');
        }

        if (token) {
            api.init({ token }).then(() => {
                if (localStorage) {
                    dispatch(getInitialDataRequest(localStorage.getItem('token')));
                }
            }).catch(() => {
                window.location.pathname = loginPath;
            });
        } else if (window.location.pathname !== loginPath) {
            window.location.pathname = loginPath;
        }
    }

    render() {
        const {
            isAuthenticated,
            is_data_ready,
            filteredByPermissionsRoutes,
        } = this.props;
        let token = '';

        if (localStorage) {
            token = localStorage.getItem('token');
        }
        const isLoading = token && window.location.pathname !== !loginPath;

        if (isLoading && !isAuthenticated) {
            return (
                <Backdrop open style={{ color: '#fff' }}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            );
        }

        if (isAuthenticated) {
            if (is_data_ready) {
                return (
                    <Router history={history}>
                        <MainRouter routes={filteredByPermissionsRoutes} />
                    </Router>
                );
            }

            return (
                <Backdrop open>
                    <CircularProgress color="inherit" />
                </Backdrop>
            );
        }
        return <AuthRouter />;
    }
}

const mapStateToProps = (state) => {
    const { is_data_ready, filteredByPermissionsRoutes } = state.App.Permissions;
    const { isAuthenticated } = state.App.App_content;
    return {
        is_data_ready,
        filteredByPermissionsRoutes,
        isAuthenticated,
    };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/modules/App/App.js